import React from 'react';
import {
  AppStoreImageContainer,
  HeaderContainer,
  ImageContainer,
  MainContainer,
  TextContainer,
} from './styles';
import finishedPayment from '../../../assets/finished-payment.svg';
import appStore from '../../../assets/app-store.svg';

export const FinishedPayment: React.FC = () => {
  return (
    <MainContainer>
      <HeaderContainer>
        <h1>Deu tudo certo!</h1>
      </HeaderContainer>

      <TextContainer>
        <span>
          Agora você já pode fazer o download do nosso aplicativo e continuar a
          sua experiência única de cuidado e bem-estar.
        </span>
      </TextContainer>

      <ImageContainer>
        <img src={finishedPayment} alt="" />
      </ImageContainer>

      <AppStoreImageContainer>
        <img src={appStore} alt="" />
      </AppStoreImageContainer>
    </MainContainer>
  );
};
